import { type LangCodes, languagesMap } from '@/data/languages';
import { isLocaleAllowed } from '@/locales/i18n.types';

export default function useLocales(staticUrl = '') {
  const route = useRoute();
  const DEFAULT_LANG: LangCodes = 'en';
  const routeLocale = (route.params?.lang ?? DEFAULT_LANG) as string;

  const currentLocale: LangCodes = isLocaleAllowed(routeLocale)
    ? routeLocale
    : DEFAULT_LANG;

  const activeLang = languagesMap[currentLocale];

  const urlLangPart =
    currentLocale !== DEFAULT_LANG ? `/${currentLocale}/` : '/';

  const { t: it, te } = useI18n();

  type TOverload = {
    (msg: string): string;
    (msg: string, options?: Record<string, string | number>): string;
    (
      msg: string,
      options?: number,
      params?: Record<string, string | number>,
    ): string;
  };

  const t: TOverload = (...args) => {
    const trLang =
      currentLocale === DEFAULT_LANG
        ? staticUrl
        : `${staticUrl}/${currentLocale}`;

    if (args.length === 2 && args[1] !== null && typeof args[1] === 'object') {
      return it(args[0], {
        ...args[1],
        tr_lang: trLang,
      });
    }

    if (
      args.length === 3 &&
      typeof args[1] === 'number' &&
      args[2] !== null &&
      typeof args[2] === 'object'
    ) {
      return it(args[0], args[1], {
        named: {
          ...args[2],
          tr_lang: trLang,
        },
      });
    }

    return it(args[0], {
      tr_lang: trLang,
    });
  };

  return {
    currentLocale,
    urlLangPart,
    activeLang,
    t,
    te,
  };
}
